module.exports = __webpack_public_path__ + "assets/media/3.599850e9.wav";